import type { FC } from "react";
import Icon from "@ch/components/Icons/Icon";
import KemImage from "@ch/assets/images/kem-speech.svg";
import ConcentricCircles from "./ConcentricCircles";

interface KemSpeechRecordingProps {
  formattedDuration: string;
  formattedDurationLimit?: string;
  isLoading: boolean;
  onCancel: () => void;
  onSend: () => void;
}

const KemSpeechRecording: FC<KemSpeechRecordingProps> = ({
  formattedDuration,
  formattedDurationLimit,
  isLoading,
  onCancel,
  onSend,
}) => {
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-between">
      <div className="mb-10 flex flex-1 flex-col items-center justify-center">
        <div className="mb-6 flex h-[240px] w-[240px] items-center justify-center rounded-full border-2 border-[#B42318]">
          <img alt="Kem Recording" className="h-32 w-32" src={KemImage} />
        </div>

        <div className="flex items-center gap-2">
          <p className="text-4xl font-bold text-white">{formattedDuration}</p>
          {formattedDurationLimit && (
            <>
              <p className="text-2xl text-white">/</p>
              <p className="text-2xl text-white">{formattedDurationLimit}</p>
            </>
          )}
        </div>
      </div>

      <div className="w-full max-w-md gap-4">
        <div className="flex w-full flex-col gap-12">
          {!isLoading && (
            <div className="flex items-center justify-center">
              <button
                className="flex items-center justify-center gap-4 rounded-full border border-[#3A4047] bg-[#1E2125] px-6 py-4 transition-transform hover:scale-105 active:scale-95"
                disabled={isLoading}
                onClick={onCancel}
                type="button"
              >
                <Icon color="#FFFFFF" name="close" size={24} />
              </button>
            </div>
          )}

          <button
            className="flex h-20 w-full items-center justify-center gap-4 rounded-full border border-[#3A4047] bg-[#1E2125] px-3 transition-transform hover:scale-105 active:scale-95 disabled:opacity-50"
            disabled={isLoading}
            onClick={onSend}
            type="button"
          >
            {isLoading ? (
              <div className="flex gap-2">
                <div className="h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.3s]" />
                <div className="h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.15s]" />
                <div className="h-2 w-2 animate-bounce rounded-full bg-white" />
              </div>
            ) : (
              <>
                <ConcentricCircles color="#DC1F4F" />
                <Icon color="#FFFFFF" name="send" size={28} />
              </>
            )}
          </button>
        </div>

        <div className="mt-4 text-center">
          <p className="text-xs text-gray-400">AI information can be wrong x</p>
        </div>
      </div>
    </div>
  );
};

export default KemSpeechRecording;
